import { render, staticRenderFns } from "./solicitudPersonalAprob2.vue?vue&type=template&id=32518f48&scoped=true"
import script from "./solicitudPersonalAprob2.vue?vue&type=script&lang=js"
export * from "./solicitudPersonalAprob2.vue?vue&type=script&lang=js"
import style0 from "./solicitudPersonalAprob2.vue?vue&type=style&index=0&id=32518f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32518f48",
  null
  
)

export default component.exports